if (!customElements.get('upsell-addon')) {
  customElements.define(
    'upsell-addon',
    class UpsellAddon extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('.upsell-addon__checkbox');
        this.variantId = this.dataset.variantId;
        this.formId = this.dataset.formId;

        // Fires every time ANY product-form on the page successfully adds
        // to the cart. We only act on it when it's *our* main product form,
        // and only when the shopper has checked the add-on box.
        this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
      }

      disconnectedCallback() {
        if (this.unsubscribeCartUpdate) this.unsubscribeCartUpdate();
      }

      onCartUpdate(event) {
        if (!this.checkbox || !this.checkbox.checked || this.checkbox.disabled) return;
        if (!event || event.source !== 'product-form') return;

        const form = document.getElementById(this.formId);
        if (!form) return;

        const mainVariantInput = form.querySelector('[name="id"]');
        if (!mainVariantInput || String(mainVariantInput.value) !== String(event.productVariantId)) return;

        this.addUpsellToCart();
      }

      addUpsellToCart() {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        const body = JSON.stringify({
          items: [{ id: this.variantId, quantity: 1 }],
          sections: cart ? cart.getSectionsToRender().map((section) => section.id) : [],
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error(response.errors || response.description);
              return;
            }

            if (cart) {
              cart.renderContents(response);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  );
}